// extracted by mini-css-extract-plugin
export default {"root":"styles_root__iaAoH","loading":"styles_loading__uLtj0"};